export interface CidadeDto {
    cidade: string;
    estado: string;
}

const cidadesMegaCap: CidadeDto[] = [
    { "cidade": "Abel Figueiredo", "estado": "PA" },
    { "cidade": "Água Azul do Norte", "estado": "PA" },
    { "cidade": "Altamira", "estado": "PA" },
    { "cidade": "Anapu", "estado": "PA" },
    { "cidade": "Araguaína", "estado": "TO" },
    { "cidade": "Baião", "estado": "PA" },
    { "cidade": "Bannach", "estado": "PA" },
    { "cidade": "Bom Jesus do Tocantins", "estado": "PA" },
    { "cidade": "Brejo Grande do Araguaia", "estado": "PA" },
    { "cidade": "Breu Branco", "estado": "PA" },
    { "cidade": "Buriti do Tocantins", "estado": "TO" },
    { "cidade": "Cachoeirinha", "estado": "TO" },
    { "cidade": "Canaã dos Carajás", "estado": "PA" },
    { "cidade": "Conceição do Araguaia", "estado": "PA" },
    { "cidade": "Cumaru do Norte", "estado": "PA" },
    { "cidade": "Curionópolis", "estado": "PA" },
    { "cidade": "Dom Eliseu", "estado": "PA" },
    { "cidade": "Eldorado do Carajás", "estado": "PA" },
    { "cidade": "Esperantina", "estado": "TO" },
    { "cidade": "Estreito", "estado": "MA" },
    { "cidade": "Floresta do Araguaia", "estado": "PA" },
    { "cidade": "Goianésia do Pará", "estado": "PA" },
    { "cidade": "Governador Archer", "estado": "MA" },
    { "cidade": "Itinga do Maranhão", "estado": "MA" },
    { "cidade": "Itupiranga", "estado": "PA" },
    { "cidade": "Jacundá", "estado": "PA" },
    { "cidade": "Magalhães de Almeida", "estado": "MA" },
    { "cidade": "Marabá", "estado": "PA" },
    { "cidade": "Medicilândia", "estado": "PA" },
    { "cidade": "Nova Ipixuna", "estado": "PA" },
    { "cidade": "Novo Repartimento", "estado": "PA" },
    { "cidade": "Ourilândia do Norte", "estado": "PA" },
    { "cidade": "Pacajá", "estado": "PA" },
    { "cidade": "Palestina do Pará", "estado": "PA" },
    { "cidade": "Paragominas", "estado": "PA" },
    { "cidade": "Parauapebas", "estado": "PA" },
    { "cidade": "Pau D'Arco", "estado": "PA" },
    { "cidade": "Pau DArco", "estado": "PA" },
    { "cidade": "Pequizeiro", "estado": "TO" },
    { "cidade": "Piçarra", "estado": "PA" },
    { "cidade": "Placas", "estado": "PA" },
    { "cidade": "Redenção", "estado": "PA" },
    { "cidade": "Rio Maria", "estado": "PA" },
    { "cidade": "Rondon do Pará", "estado": "PA" },
    { "cidade": "Santa Maria das Barreiras", "estado": "PA" },
    { "cidade": "Santana do Araguaia", "estado": "PA" },
    { "cidade": "Sapucaia", "estado": "PA" },
    { "cidade": "São Domingos do Araguaia", "estado": "PA" },
    { "cidade": "São Domingos do Capim", "estado": "PA" },
    { "cidade": "São Félix do Xingu", "estado": "PA" },
    { "cidade": "São Geraldo do Araguaia", "estado": "PA" },
    { "cidade": "São João do Araguaia", "estado": "PA" },
    { "cidade": "São Pedro da Água Branca", "estado": "MA" },
    { "cidade": "São Sebastião do Tocantins", "estado": "TO" },
    { "cidade": "Tailândia", "estado": "PA" },
    { "cidade": "Trairão", "estado": "PA" },
    { "cidade": "Tucumã", "estado": "PA" },
    { "cidade": "Tucuruí", "estado": "PA" },
    { "cidade": "Ulianópolis", "estado": "PA" },
    { "cidade": "Vila Nova dos Martírios", "estado": "MA" },
    { "cidade": "Xambioá", "estado": "TO" },
    { "cidade": "Xinguara", "estado": "PA" }
]

const cidadesRondonCap: CidadeDto[] = [
    {"cidade": "Alta Alegre dos Parecis", "estado": "RO"},
    {"cidade": "Alta Floresta D'Oeste", "estado": "RO"},
    {"cidade": "Alto Alegre dos Parecis", "estado": "RO"},
    {"cidade": "Alto Paraíso", "estado": "RO"},
    {"cidade": "Alvorada D'Oeste", "estado": "RO"},
    {"cidade": "Ariquemes", "estado": "RO"},
    {"cidade": "Buritis", "estado": "RO"},
    {"cidade": "Cabixi", "estado": "RO"},
    {"cidade": "Cacaulândia", "estado": "RO"},
    {"cidade": "Cacoal", "estado": "RO"},
    {"cidade": "Campo Novo de Rondônia", "estado": "RO"},
    {"cidade": "Candeias do Jamari", "estado": "RO"},
    {"cidade": "Castanheiras", "estado": "RO"},
    {"cidade": "Cerejeiras", "estado": "RO"},
    {"cidade": "Chupinguaia", "estado": "RO"},
    {"cidade": "Colorado do Oeste", "estado": "RO"},
    {"cidade": "Corumbiara", "estado": "RO"},
    {"cidade": "Costa Marques", "estado": "RO"},
    {"cidade": "Cujubim", "estado": "RO"},
    {"cidade": "Espigão D'Oeste", "estado": "RO"},
    {"cidade": "Governador Jorge Teixeira", "estado": "RO"},
    {"cidade": "Guajará-Mirim", "estado": "RO"},
    {"cidade": "Itapuã do Oeste", "estado": "RO"},
    {"cidade": "Jaru", "estado": "RO"},
    {"cidade": "Ji-Paraná", "estado": "RO"},
    {"cidade": "Machadinho D'Oeste", "estado": "RO"},
    {"cidade": "Ministro Andreazza", "estado": "RO"},
    {"cidade": "Mirante da Serra", "estado": "RO"},
    {"cidade": "Monte Negro", "estado": "RO"},
    {"cidade": "Nova Brasilândia D'Oeste", "estado": "RO"},
    {"cidade": "Nova Mamoré", "estado": "RO"},
    {"cidade": "Nova União", "estado": "RO"},
    {"cidade": "Novo Horizonte do Oeste", "estado": "RO"},
    {"cidade": "Ouro Preto do Oeste", "estado": "RO"},
    {"cidade": "Parecis", "estado": "RO"},
    {"cidade": "Pedras Negras", "estado": "RO"},
    {"cidade": "Pimenta Bueno", "estado": "RO"},
    {"cidade": "Pimenteiras do Oeste", "estado": "RO"},
    {"cidade": "Porto Velho", "estado": "RO"},
    {"cidade": "Presidente Médici", "estado": "RO"},
    {"cidade": "Primavera de Rondônia", "estado": "RO"},
    {"cidade": "Rio Crespo", "estado": "RO"},
    {"cidade": "Rolim de Moura", "estado": "RO"},
    {"cidade": "Santa Luzia D'Oeste", "estado": "RO"},
    {"cidade": "São Felipe D'Oeste", "estado": "RO"},
    {"cidade": "São Francisco do Guaporé", "estado": "RO"},
    {"cidade": "São Miguel do Guaporé", "estado": "RO"},
    {"cidade": "Seringueiras", "estado": "RO"},
    {"cidade": "Teixeirópolis", "estado": "RO"},
    {"cidade": "Theobroma", "estado": "RO"},
    {"cidade": "Urupá", "estado": "RO"},
    {"cidade": "Vale do Anari", "estado": "RO"},
    {"cidade": "Vale do Paraíso", "estado": "RO"},
    {"cidade": "Vilhena", "estado": "RO"}
]

const cidadesAcreCap: CidadeDto[] = [
    {"cidade": "Acrelândia", "estado": "AC"},
    {"cidade": "Assis Brasil", "estado": "AC"},
    {"cidade": "Boca do Acre", "estado": "AM"},
    {"cidade": "Brasiléia", "estado": "AC"},
    {"cidade": "Bujari", "estado": "AC"},
    {"cidade": "Capixaba", "estado": "AC"},
    {"cidade": "Cruzeiro do Sul", "estado": "AC"},
    {"cidade": "Epitaciolândia", "estado": "AC"},
    {"cidade": "Feijó", "estado": "AC"},
    {"cidade": "Jordão", "estado": "AC"},
    {"cidade": "Mâncio Lima", "estado": "AC"},
    {"cidade": "Manoel Urbano", "estado": "AC"},
    {"cidade": "Marechal Thaumaturgo", "estado": "AC"},
    {"cidade": "Pauini", "estado": "AM"},
    {"cidade": "Plácido de Castro", "estado": "AC"},
    {"cidade": "Porto Acre", "estado": "AC"},
    {"cidade": "Porto Walter", "estado": "AC"},
    {"cidade": "Rio Branco", "estado": "AC"},
    {"cidade": "Rodrigues Alves", "estado": "AC"},
    {"cidade": "Santa Rosa do Purus", "estado": "AC"},
    {"cidade": "Sena Madureira", "estado": "AC"},
    {"cidade": "Senador Guiomard", "estado": "AC"},
    {"cidade": "Tarauacá", "estado": "AC"},
    {"cidade": "Xapuri", "estado": "AC"}
]

const cidadesRoraiCap: CidadeDto[] = [
    {"cidade": "Alto Alegre", "estado": "RR"},
    {"cidade": "Amajari", "estado": "RR"},
    {"cidade": "Boa Vista", "estado": "RR"},
    {"cidade": "Bonfim", "estado": "RR"},
    {"cidade": "Cantá", "estado": "RR"},
    {"cidade": "Caracaraí", "estado": "RR"},
    {"cidade": "Caroebe", "estado": "RR"},
    {"cidade": "Iracema", "estado": "RR"},
    {"cidade": "Mucajaí", "estado": "RR"},
    {"cidade": "Normandia", "estado": "RR"},
    {"cidade": "Pacaraima", "estado": "RR"},
    {"cidade": "Rorainópolis", "estado": "RR"},
    {"cidade": "São João da Baliza", "estado": "RR"},
    {"cidade": "São Luiz", "estado": "RR"},
    {"cidade": "Uiramutã", "estado": "RR"}
]

class CidadesService {
    async buscarCidades(): Promise<CidadeDto[]> {
        switch (import.meta.env.VITE_APP_THEME) {
            case 'AcreCap':
                return cidadesAcreCap;
            case 'MegaCap':
                return cidadesMegaCap;
            case 'RondonCap':
                return cidadesRondonCap;
            case 'RoraiCap':
                return cidadesRoraiCap;
            default:
                return [];
        }
    }
}

//eslint-disable-next-line
export default new CidadesService();